module.exports = __webpack_public_path__ + "static/offer-fizjoteriapia-image-1@2x-267ccda05a22445d7cb85c2080a8a374.png";